import type { BetaSettingsSection } from '@/types/beta-dashboard'

export const betaAdvancedSettingsLinks = [
    {
        id: 'seo',
        routeName: 'dashboard.seo',
        title: 'SEO e informações do site',
        navigationTitle: 'SEO',
        navigationDescription: 'Busca e indexação',
        description: 'Título, idioma, descrição e configurações de indexação.',
        leading: 'SEO',
    },
    {
        id: 'advertising',
        routeName: 'dashboard.publicidades',
        title: 'Publicidade',
        navigationTitle: 'Publicidade',
        navigationDescription: 'Banners e selos',
        description: 'Gerencie os espaços publicitários disponíveis no legado.',
        leading: 'Ad',
    },
    {
        id: 'link-building',
        routeName: 'dashboard.linkBuilding',
        title: 'Link building',
        navigationTitle: 'Link building',
        navigationDescription: 'Divulgação e links',
        description: 'Recursos de divulgação e links do projeto existente.',
        leading: '↗',
    },
    {
        id: 'redirects',
        routeName: 'dashboard.redirects',
        title: 'Redirecionamentos',
        navigationTitle: 'Redirecionamentos',
        navigationDescription: 'Encaminhar endereços',
        description: 'Controle os redirecionamentos já suportados pelo painel.',
        leading: '↪',
    },
    {
        id: 'files',
        routeName: 'dashboard.files',
        title: 'Arquivos',
        navigationTitle: 'Arquivos',
        navigationDescription: 'Gerenciar arquivos',
        description: 'Acesse a administração avançada de arquivos.',
        leading: '▤',
    },
] as const

export type BetaAdvancedSettingsRouteName = typeof betaAdvancedSettingsLinks[number]['routeName']

const betaSectionByAdvancedRoute: Record<BetaAdvancedSettingsRouteName, BetaSettingsSection> = {
    'dashboard.seo': 'seo',
    'dashboard.publicidades': 'advertising',
    'dashboard.linkBuilding': 'link-building',
    'dashboard.redirects': 'redirects',
    'dashboard.files': 'files',
}

export const betaSettingsSectionForAdvancedRoute = (
    routeName: BetaAdvancedSettingsRouteName,
) => betaSectionByAdvancedRoute[routeName]
